export const getName = (user) => {
 if (user.firstName === null || user.firstName === undefined || user.firstName === "") {
   return user.username;
 } else {
   return user.firstName + " " + user.lastName;
 }
}